export const getAxisLabels = (maxValue: number) => {
  let axisLabels = [25, 50, 75, 100];

  if (maxValue < 50) {
    axisLabels = [25, 50];
  } else if (maxValue < 75) {
    axisLabels = [25, 50, 75];
  }

  return axisLabels;
};
